module.exports = __webpack_public_path__ + "media/images/athletes/3430-e8015cf8a7acd680816b3d639a71e159.png";